import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { DateRangeSelector, DateRange } from './model';
import { DatePicker } from 'portcall/datetimepicker/view';

function dateRangeName(range : DateRange) {
    if (range === DateRange.AllDates) return 'All Dates';
    if (range === DateRange.ThisWeek) return 'This Week';
    if (range === DateRange.LastWeek) return 'Last Week';
    if (range === DateRange.ThisMonth) return 'This Month';
    if (range === DateRange.LastMonth) return 'Last Month';
    if (range === DateRange.ThisYear) return 'This Year';
    if (range === DateRange.LastYear) return 'Last Year';
    if (range === DateRange.Custom) return 'Custom';
    throw new Error('Unknown date range: ' + range);
}

export const DateRangeSelectorView = SuperCritical(({ model: m } : { model : DateRangeSelector }) =>
    // <span className="date-range-selector">
    <span className={cx('date-range-selector', {
            'date-range-custom': m.Range() === DateRange.Custom
        })}>
        <select className="range pc-select"
            value={m.Range()}
            onChange={e => m.Range(+e.currentTarget.value)}>
            {m.AllowedRanges.map(r =>
                <option value={r} key={r}>{dateRangeName(r)}</option>
            )}
        </select>
        <span className="pc-select-chevron"></span>
        {m.Range() === DateRange.Custom &&
            <span>
                <div className="datepicker-container">
                    <DatePicker value={m.FromDate} localization={m.Localization} />
                </div>
                <div className="text">to</div>
                <div className="datepicker-container">
                    <DatePicker value={m.CustomToDate} localization={m.Localization} />
                </div>
            </span>
        }
    </span>
);


// WEBPACK FOOTER //
// ./apps/portcall/daterangeselector/view.tsx